import { Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, ViewChild, ContentChild, TemplateRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import _ from 'lodash';
import { BroadCastService } from '../../services/broadcast.service';
@Component({
  standalone: false,
  selector: 'mysynch-select',
  templateUrl: '../app/form-controls/mysynch-select/mysynch-select.view.html',
  styleUrls:['../app/form-controls/mysynch-select/mysynch-select.style.css','../css/ng-select/default.theme.css','../css/ng-select/ng-select.component.css']
})
export class MySynchSelect implements OnInit, OnDestroy {

    @ViewChild('ngSelectRef') ngSelect: NgSelectComponent;

    @ContentChild('customOption') customOptionTemplate: TemplateRef<any>;
    @ContentChild('customLabel') customLabelTemplate: TemplateRef<any>;
    
    @Input() isDisabled: boolean = false;
    @Input() defaultSelectedItem:any = {};
    @Input() controlId:any = "mysynchSelect";
    @Input() labelProperty: string = "";
    @Input() valueProperty: any = null;
    @Input() placeholder: string = "Select";
    @Input() closeOnSelect: boolean = true;
    @Input() multiple: boolean = false;
    @Input() searchable: boolean = false;
    @Input() virtualScroll: boolean = false;
    @Input() labelDisplayField: string ="";
    @Input() valueKeyField: string = "";
    @Input() orderByFields: any[];
    @Input() orderByDirections: any[] = ['asc'];
    @Input() appendTo: string = null;
    
    //@Input() selectedItem:any = this.defaultSelectedItem;
    _selectedItem:any = this.defaultSelectedItem;
    @Input() set selectedItem(value: any) {
      this._selectedItem = value;
    }
    get selectedItem(): any {
      return this._selectedItem;
    }

    _items: any[] = [];
    @Input() set items(items: any[]){
        //console.log('Setting items in MySynchSelect:', items);
        this._items = [..._.sortByOrder(items, this.orderByFields, this.orderByDirections)];
    };
    @Input() disableDemoUserFilter: boolean = true;
    @Input() demoUserValueKey: string = "id";

    @Output() onSelectAdd = new EventEmitter<any[]>();
    @Output() onSelectChange = new EventEmitter<any[]>();
    @Output() onSelectOpen = new EventEmitter<any>();
    @Output() onSelectClose = new EventEmitter<any>()


    private onClearControlSubscription: any;
    
    
    
    _:any;
    
    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject(BroadCastService) private broadCastSrv:BroadCastService){
      this._ = _;
    }
    ngOnInit(){
      this.onClearControlSubscription = this.broadCastSrv.onClearControl().subscribe((controlId)=>{
          if(_.isEqual(controlId,this.controlId)){
            this._selectedItem = this.defaultSelectedItem;
          }
       });
    }

    ngOnDestroy(){
      if(this.onClearControlSubscription){
        this.onClearControlSubscription.unsubscribe();
      }
      this.onSelectAdd.complete();
      this.onSelectChange.complete();
      this.onSelectOpen.complete();
      this.onSelectClose.complete();
    }

    trackByFn = (item)=>{
      return _.get(item,this.valueProperty); // or item.id
   }

    get items():any[] {
      return this._items;
    }

    getSelectedItemLabel(selectedItem:any){
      var itemLabel =  _.get( _.find(this._items,(item)=>_.isEqual(_.get(selectedItem,this.valueProperty),_.get(item,this.valueProperty))),this.labelProperty);
      return itemLabel;
    }

    onOpen(){
     this.onSelectOpen.emit();
    }
    onClose(){
     this.onSelectClose.emit();
    }

    onAdd(option:any):void{
      this.onSelectAdd.emit(option);
    }
    
    onChange(options:any):void{
        this.onSelectChange.emit(options);   
   }

   onRemove(){
      
   }
    closeDropdown() {
      if (this.ngSelect) {
        this.ngSelect.close();
      }
    }
   
}